import { render, staticRenderFns } from "./RegisterAgency.vue?vue&type=template&id=6f8ce21a&scoped=true"
import script from "./RegisterAgency.vue?vue&type=script&lang=js"
export * from "./RegisterAgency.vue?vue&type=script&lang=js"
import style0 from "./RegisterAgency.vue?vue&type=style&index=0&id=6f8ce21a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ce21a",
  null
  
)

export default component.exports